import React, { Component } from "react"
import { Link } from "gatsby"

export class Footer extends Component {
  render() {
    return (
      <>
        <div className="advertisement-container">
          

         
        </div>

        <div className="footer">
          <Link to="/" className="footerLink">
            Home
          </Link>
          <Link to="/about" className="footerLink">
            About
          </Link>
          <Link to="/contact" className="footerLink">
            Contact
          </Link>
          <Link to="/faq" className="footerLink">
            FAQ
          </Link>
        </div>
        
        {/* Partner Links Section for SEO */}
        <div className="partner-links">
          <span className="partner-label">Partners:</span>
          <a 
            href="https://njtautomation.com/" 
            target="_blank" 
            rel="noopener"
            className="partner-link"
            title="NJT Automation - Industrial Electronics Supply and Repair"
          >
            NJT Automation
          </a>
          <span className="partner-separator">|</span>
          <a 
            href="https://njtautomation.com/industrial-electronics-repair/" 
            target="_blank" 
            rel="noopener"
            className="partner-link"
            title="Industrial Electronics Repair - HMI, PLC, VFD Repair Services"
          >
            Industrial Electronics Repair
          </a>
          <span className="partner-separator">|</span>
          <a 
            href="https://repairmode.com" 
            target="_blank" 
            rel="noopener"
            className="partner-link"
            title="RepairMode - Electronics Repair Marketplace"
          >
            RepairMode
          </a>
        </div>
      </>
    )
  }
}

export default Footer
